import React from "react";
import { isValid } from "redux-form";
import { useSelector } from "react-redux";

import { Button } from "rhombus-react";

import BasicModal from "widgets/modals/BasicModal";
import PartnerVASTForm from "./PartnerVASTForm";
import { PARTNER_VAST_FORM } from "utils/forms";

const validForm = isValid(PARTNER_VAST_FORM);

export default function PartnerVAST(props){
	let {
			navigationActions,
			commonModalProps,
		} = props
		, {
			popModal,
		} = navigationActions
		, isValidForm = useSelector(validForm)
		;

	function renderContent(){
		return <PartnerVASTForm libraryId={props.libraryId} onClose={commonModalProps.onClose} />;
	}

	function renderFooter(){
		return [
			<Button
				key="back"
				theme="default"
				onClick={popModal}
				// disabled={isSubmitting}
			>
				Back
			</Button>
			, <Button
				key="submit"
				theme="green"
				type="submit"
				form={PARTNER_VAST_FORM}
				disabled={!isValidForm}
			>
				Create VAST Creative
			</Button>
		];
	}

	const modalProps = {
		title: "Create VAST",
		className: "partner-vast-tags",
		onClose:popModal,
		renderContent,
		renderFooter,
	};

	return <BasicModal {...modalProps} />;
}

PartnerVAST.displayName = "PartnerVAST";
PartnerVAST.defaultProps = {
	libraryId:-1,
};
